<template>
  <b-row class="mb-3" >
    <b-col cols="6" class="d-flex justify-content-start align-items-center">
      <h5>
        النشاط {{ getArrangement(i+1) }}

      </h5>
      
    </b-col>
    <b-col cols="6" class="d-flex justify-content-end align-items-center">
      <b-button
          variant="outline-danger"
          :disabled="i===0 && item.length === 1"
          @click="onClickedDelete(i)"
      >
        <feather-icon icon="XIcon" />
        حذف
      </b-button>
    </b-col>
    <b-col cols="12">
      <hr />
    </b-col>
    <b-col cols="3" v-if="!(item.program_id ? item.program_id.id=== 0 || item.program_id.id== 'undefined' : false )">
      <form-select
          rules="required"
          :label="`${i+1}-البرنامج`"
          :id="`program_${i}`"
          v-model="item.program_id"
          :reduce="(x) => x"
          :getOptionLabel="(x) => x.name"
          ep="/v2/selects/programs"
      />
    </b-col>
    <b-col cols="3">
      <form-select
          :label="`${i+1}-النشاط`"
          v-model="item.activity_id"
          :getOptionLabel="(x) => x.name"
          :reduce="(x) => x"
          :id="`activity_${i}`"
          :ep="activitiesEp"
          rules="required"
          :ref="`activity_${i}`"
      />
    </b-col>
    <b-col cols="3">
      <form-input
          :id="`beneficiaries_number_${i}`"
          :label="`${i+1}-عدد المستفيدين`"
          v-model.number="item.beneficiaries_number"
          rules="required"
      />
    </b-col>
    <b-col cols="3">
      <form-input
          :id="`funds_${i}`"
          :label="`${i+1}-الموازنة`"
          v-model.number="item.funds"
          rules="required"
          class="justify-content-center align-items-center"
      />
    </b-col>
    <b-col cols="3">
      <!-- <form-select
        rules="required"
        :label="`${i+1}-التنفيذ`"
        id="months"
        v-model="item.months"
        :reduce="(x) => x.value"
        :getOptionLabel="(x) => x.text"
        multiple
        :closeOnSelect="false"
        :options="options"
        
      /> -->
      <form-select
        rules="required"
        :label="`${i+1}-التنفيذ`"
        id="months"
        v-model="item.months"
        :reduce="(x) => x.id"
        :getOptionLabel="(x) => x.name_ar"
        :closeOnSelect="false"
        :options="options"
        multiple
        
      />

    </b-col>
    <b-col cols="3">

      <form-select
        :label="`${i+1}-المحافظة`"
        v-model="item.governorate_id"
        :getOptionLabel="(x) => x.name_ar"
        :reduce="(x) => x"
        :id="`jobs_governorate_${i}`"
        ep="v2/guest/selects/governorates"
        multiple
        :closeOnSelect="false"
      />
    </b-col>
    <b-col cols="2" style="margin-top: 25px;">
      <b-form-checkbox
          @change="onUrgentChecked($event, item)"
          class="inline custom-control-primary"
          v-model="isUrgent"
      >
        <span> نشاط طارئ </span>
      </b-form-checkbox>
    </b-col>
    
    <hr />
  </b-row>
</template>

<script>
import { required } from "@validations";
import { ValidationObserver } from "vee-validate";

import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BFormCheckbox,
  BFormCheckboxGroup,
  BButton,
} from "bootstrap-vue";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import saveBtn from "@/components/loader-btn";
import formDatepicker from "@/components/form-datepicker";
import { arrangement } from "@/utils/utils";
const initForm = {
  activity_id: null,
  funds: null,
  beneficiaries_number: null,
  months: [],
};

export default {
  components: {
    ValidationObserver,
    formInput,
    formSelect,
    BButton,
    formDatepicker,
    saveBtn,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BForm,
    BFormRadio,
    BFormTextarea,
    BFormCheckbox,
    BFormCheckboxGroup,
  },
  props: {
    item: Object,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
    i: Number,
  },
  data() {
    return {
      form: {},
      ep: null,
      isUrgent:this.item.program_id === 0 ? true : false ,
      selected: [],
      options: [
        { name_ar: "كانون الثاني", id: 1 },
        { name_ar: "شباط", id: 2 },
        { name_ar: "آذار", id: 3 },
        { name_ar: "نيسان", id: 4 },
        { name_ar: "أيار", id: 5 },
        { name_ar: "حزيران", id: 6 },
        { name_ar: "تموز", id: 7 },
        { name_ar: "آب", id: 8 },
        { name_ar: "أيلول", id: 9 },
        { name_ar: "تشرين الأول", id:10 },
        { name_ar: "تشرين الثاني", id: 11 },
        { name_ar: "كانون الأول", id: 12 },
      ],
      required,
    };
  },
  computed: {
    modalOpen() {
      this.$nextTick(() => {
        this.init(this.intializeForm);
      });
    },
    // isUrgent(){
    //   return this.item.program_id === 0 ? true : false 
    // },
    activitiesEp() {
      console.log("this.item.program_id" , this.item.program_id)
      return this.item.program_id || this.item.program_id === 0
          ? "v2/selects/activities/" + this.item.program_id.id
          : "v";
    },
   
  },
  watch: {
    activitiesEp(newVal) {
      if (this.$refs[`activity_${this.i}`] && this.activitiesEp.length > 1)
        this.$refs[`activity_${this.i}`].refreshOptions(newVal);
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
      this.item.program_id = 1
    },
    onUrgentChecked(val, item) {
      if (val)  this.$set(this.item,'program_id',{id:0 , name : null});
      else this.$set(this.item,'program_id',null);
    },
    getArrangement(num){
      return arrangement(num)
    },
    onClickedDelete(i){
      this.$emit("i", i);
    },
  },
};
</script>

<style lang="scss">
.checkbox-cont {
  .bv-no-focus-ring {
    display: grid;
    grid-template-columns: auto auto auto auto;
  }
}
</style>